import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from 'react-icons/ai'
import cn from 'classnames'
import Button from 'react-bootstrap/Button'
import s from './BarHandle.module.scss'

interface Props {
  variant: 'left' | 'right'
  onMouseDown?: () => void
}

const VARIANT = {
  right: <AiOutlineDoubleLeft />,
  left: <AiOutlineDoubleRight />,
}

const defaultProps = {
  onMouseDown: () => null,
}

const BarHandle = ({ variant, onMouseDown }: Props): JSX.Element => (
  <div className="position-relative">
    <Button
      onMouseDown={onMouseDown}
      variant="none"
      className={cn(s.barHandle, s[variant])}
    >
      {VARIANT[variant]}
    </Button>
  </div>
)

BarHandle.defaultProps = defaultProps
export default BarHandle
